import React, {Fragment} from 'react';

import _ from 'topmeteo/utils/i18n';

import {useLightBox} from 'topmeteo/general/components/LightBox/Manager';

import SettingsLightBox from './SettingsLightBox';

const Title = _('Settings');

const SettingsButton = () => {
    const {show, onClick, ...props} = useLightBox();

    return (
        <Fragment>
            <button className="settings" title={Title} onClick={onClick}>
                <i className="icon icon-cog" />
            </button>
            {show && <SettingsLightBox {...props} />}
        </Fragment>
    );
};

export default SettingsButton;
